import React, {createContext, ReactNode, useContext} from 'react';
import {Store} from "../../entity/core/store";
import UserStore from "./user-store";
import OrganizationStore from "./organization-store";
import CountyStore from "./county-store";
import {useAgent} from "../agent/agent";
import StateStore from "./state-store";
import TitleSectionTemplateStore from "./title-section-template-store";
import TitleStore from "./title-store";
import SectionStore from "./section-store";
import DocumentStore from "./document-store";
import TitleTemplateStore from "./title-template-store";
import SearchStore from "./search-store";
import SubscriptionStore from "./subscription-store";
import ScraperConfigStore from "./scraper-config-store";
import CountyLinkStore from "./county-link-store";
import AuditLogsStore from "./audit-logs-store";
import ProjectStore from "./project-store";
import InvoiceTemplateStore from "./invoice-template-store";
import TitleSummaryRequestStore from './title-summary-request-store';
import TitleSummaryTemplateStore from './title-summary-template-store';
import BrandingTemplateStore from "./branding-template-store";
import LineListRequestStore from './line-list-request-store';
import LineListTemplateStore from './line-list-template-store';
import MetadataStore from "./metadata-store";
import MarketplaceStore from "./marketplace-store";

const StoreContext = createContext<Store | undefined>(undefined);

export const StoreProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const agent = useAgent();

  const store: Store = {
    userStore: new UserStore(agent.userAgent),
    organizationStore: new OrganizationStore(agent.organizationAgent),
    countyStore: new CountyStore(agent.countyAgent),
    stateStore: new StateStore(agent.stateAgent),
    titleSectionTemplateStore: new TitleSectionTemplateStore(agent.titleSectionTemplateAgent),
    titleStore: new TitleStore(agent.titleAgent),
    sectionStore: new SectionStore(agent.sectionAgent),
    documentStore: new DocumentStore(agent.documentAgent),
    titleTemplateStore: new TitleTemplateStore(agent.titleTemplateAgent),
    searchStore: new SearchStore(agent.searchAgent),
    subscriptionStore: new SubscriptionStore(agent.subscriptionAgent),
    scraperConfigStore: new ScraperConfigStore(agent.scraperConfigAgent),
    countyLinkStore: new CountyLinkStore(agent.countyLinkAgent),
    auditLogsStore: new AuditLogsStore(agent.auditLogsAgent),
    projectStore: new ProjectStore(agent.projectAgent),
    invoiceTemplateStore: new InvoiceTemplateStore(agent.invoiceTemplateAgent),
    titleSummaryRequestStore: new TitleSummaryRequestStore(agent.titleSummaryRequestAgent),
    titleSummaryTemplateStore: new TitleSummaryTemplateStore(agent.titleSummaryTemplateAgent),
    brandingTemplateStore: new BrandingTemplateStore(agent.brandingTemplateAgent),
    lineListRequestStore: new LineListRequestStore(agent.lineListRequestAgent),
    lineListTemplateStore: new LineListTemplateStore(agent.lineListTemplateAgent),
    metadataStore: new MetadataStore(agent.metadataAgent),
    marketplaceStore: new MarketplaceStore(agent.marketplaceAgent)
  };

  return (
      <StoreContext.Provider value={store}>
          {children}
      </StoreContext.Provider>
  );
}

export const useStore = (): Store => {
  const context = useContext(StoreContext);
  if (context === undefined) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
}
